// extracted by mini-css-extract-plugin
module.exports = {"footer":"CreditsFooter-module--footer--3pj-e"};